import { combineReducers } from 'redux'
import { routerReducer } from '../routerHistory'
import { reducer as oidcReducer } from 'redux-oidc'

import invoiceReducer from './invoice.reducer'
import invoiceReviews from './invoiceReview.reducer'
import customerReducer from './customer.reducer'
import expenseReducer from './expense.reducer'
import profileReducer from './profile.reducer'
import taxReducer from './tax.reducer'
import adminReducer from './admin.reducer'
import salaryReducer from './salary.reducer'
import registerForm from './register.reducer'
import loginForm from './login.reducer'
import clientReducer from './client.reducer'
import dashboardReducer from './dashboard.reducer'
import resetPassword from './resetPassword.reducer'
import language from './lang.reducer'
import adminUser from './adminUser.reducer'
import loaderReducer from './loader.reducer'
import routerLocationsReducer from './routerLocations.reducer'
import companyListsReducer from './companyDetails.reducer'
import openforworkReducer from './openForWork.reducer'
import assignmentReducer from './assignment.reducer'
import applicationReducer from './application.reducer'
import { formReducer } from '../form'
import taxAreaReducer from './taxArea.reducer'
import logoReducer from './logo.reducer'
import paginationReducer from './dropDownPagination.reducer'
import workShiftUserReducer from './workShiftUser.reducer'

import { LOGOUT } from '../constants'

/**
 * TODO: describe this
 *
 * @author Pragya Gupta
 */

const appReducer = combineReducers({
  adminUser,
  loader: loaderReducer,
  oidc: oidcReducer,
  router: routerReducer,
  routerLocations: routerLocationsReducer,
  invoice: invoiceReducer,
  invoiceReviews: invoiceReviews,
  customer: customerReducer,
  expense: expenseReducer,
  profile: profileReducer,
  tax: taxReducer,
  admin: adminReducer,
  salary: salaryReducer,
  register: registerForm,
  login: loginForm,
  client: clientReducer,
  dashboard: dashboardReducer,
  resetPassword: resetPassword,
  language: language,
  companyLists: companyListsReducer,
  openForWork: openforworkReducer,
  assignment: assignmentReducer,
  application: applicationReducer,
  workShiftUser: workShiftUserReducer,
  form: formReducer,
  industryTaxArea: taxAreaReducer,
  logo: logoReducer,
  pagination: paginationReducer
})

const rootReducer = (state, action) => {
  return appReducer(
    action.type === LOGOUT
      ? {
          ...appReducer({}, {}),
          form: (state && { ...state.form, userSelector: {} }) || {}
        }
      : state,
    action
  )
}

export default rootReducer
